module.exports = __webpack_public_path__ + "static/img/04_click.6be5c1d2.png";